import { ErrorWindow } from "components/ErrorWindow";
import { WarningWindow } from "components/WarningWindow";
import { ReactComponent as RSLogo } from "images/rs-logo.svg";
import { Link } from "react-router-dom";
import { Spinner } from "UI/Spinner";
import { Container, Header } from "../Dashboard.style";
import { LoginForm } from "./LoginForm";

export const Login = ({
  error,
  setError,
  loading,
  setLoading,
  notification,
  originator,
  handleBookmarkInfoClose,
  handleBookmarkInfoButtonClick,
  reloadButtons,
}) => {
  const isDev = process.env.REACT_APP_CURRENT_ENV === "dev";
  const currentYear = new Date().getFullYear();

  return (
    <Container>
      <Header>
        <RSLogo width={"103px"} />
      </Header>
      <div className="flex-1 mb-10 flex flex-col items-center justify-center gap-6">
        <div
          className={`p-4 sm:p-8 flex flex-col gap-4 rounded-xl border border-solid
                border-gray-300 shadow-lg min-w-80 sm:min-w-96`}
        >
          <LoginForm
            setError={setError}
            reloadButtons={reloadButtons}
            setLoading={setLoading}
          />
        </div>
        <div className="text-xs sm:text-sm flex flex-row flex-wrap justify-center items-center gap-2">
          Don't have an account?{" "}
          <Link
            to={`https://app${isDev ? "-dev" : ""}.referral-stream.com/sign_up`}
            target="_blank"
          >
            <span className="text-blue-900">Register</span>
          </Link>
        </div>
      </div>
      <div className="mb-4 text-gray-500 text-sm flex-grow-0 flex-shrink-0 text-center">
        Copyright © {currentYear} Referral Stream. All rights reserved.
      </div>
      {!error && !loading && notification && (
        <WarningWindow
          title={<>Hello {originator?.firstName}!</>}
          content={notification}
          withCloseButton
          handleClose={handleBookmarkInfoClose}
          handleButtonClick={handleBookmarkInfoButtonClick}
        />
      )}
      {error && <ErrorWindow error={error} handleClose={() => setError("")} />}
      {loading && <Spinner />}
    </Container>
  );
};
